export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://riycpvxjjdadylliazrs.supabase.co";

